import ThisModule from "./SkypeIdSection";

export default ThisModule;
